import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import MaintenanceHero from './components/MaintenanceHero';
import MaintenanceServices from './components/MaintenanceServices';
import EmergencyContact from './components/EmergencyContact';
import MaintenanceProcess from './components/MaintenanceProcess';
import MaintenanceFAQ from './components/MaintenanceFAQ';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Dépannage Urgence 24/7 Neuenegg - Maintenance CVSE - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": { "@type": "PostalAddress", "streetAddress": "Austrasse 95", "addressLocality": "Neuenegg", "addressRegion": "Fribourg", "postalCode": "3176", "addressCountry": "CH" },
    "geo": { "@type": "GeoCoordinates", "latitude": "46.233333", "longitude": "6.083333" },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "00:00", "closes": "23:59", "description": "Urgences 24h/24 7j/7" }
    ],
    "priceRange": "CHF"
  },
  "areaServed": ["Genève", "Meyrin", "Carouge", "Lancy", "Vernier", "Onex", "Thônex", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Dépannage urgence 24h/24 7j/7 à Genève. Électricité, plomberie, chauffage, ventilation. Intervention rapide garantie. Appelez le 079 761 62 82.",
  "serviceType": "Maintenance et dépannage urgence 24/7",
  "availableChannel": {
    "@type": "ServiceChannel",
    "servicePhone": "+41797616282",
    "availableLanguage": "fr",
    "serviceUrl": "https://casarenovaplus.ch/maintenance"
  },
  "offers": { "@type": "Offer", "availability": "https://schema.org/InStock", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "CHF", "description": "Devis gratuit" } },
  "url": `${import.meta.env.VITE_SITE_URL}/maintenance`
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Intervenez-vous vraiment 24h/24 et 7j/7 à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Oui, HB SERVICES assure un service de dépannage d'urgence 24h/24 et 7j/7 dans tout le canton de Genève et en Suisse romande. Que ce soit en pleine nuit, le week-end ou les jours fériés, nos techniciens sont disponibles. Appelez le 079 761 62 82 pour une intervention immédiate." }
    },
    {
      "@type": "Question",
      "name": "Quel est le délai d'intervention pour une urgence à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Pour les urgences à Genève, notre délai d'intervention moyen est de 30 à 90 minutes selon votre localisation et l'heure de l'appel. Nous intervenons en priorité pour les pannes électriques, les fuites d'eau, les pannes de chauffage en hiver et les problèmes de ventilation critiques." }
    },
    {
      "@type": "Question",
      "name": "Quels types de pannes prenez-vous en charge en urgence ?",
      "acceptedAnswer": { "@type": "Answer", "text": "HB SERVICES intervient en urgence pour : pannes électriques (disjoncteur, court-circuit, panne de courant), fuites d'eau et dégâts des eaux, pannes de chauffage (chaudière, pompe à chaleur), problèmes de ventilation et climatisation, et tout autre problème technique CVSE nécessitant une intervention rapide." }
    },
    {
      "@type": "Question",
      "name": "Proposez-vous des contrats de maintenance préventive à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Oui, HB SERVICES propose des contrats de maintenance préventive sur mesure pour particuliers, entreprises et gestionnaires d'immeubles à Genève. Ces contrats incluent des visites régulières programmées, des contrôles complets de vos installations, le remplacement préventif des pièces d'usure et un accès prioritaire à notre service d'urgence." }
    },
    {
      "@type": "Question",
      "name": "Combien coûte une intervention d'urgence à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Le coût d'une intervention d'urgence dépend de la nature de la panne, de l'heure d'intervention et du temps de travail nécessaire. HB SERVICES applique une transparence totale : le technicien établit un devis sur place avant de commencer les travaux. Pas de mauvaise surprise. Contactez-nous au 079 761 62 82 pour plus d'informations." }
    },
    {
      "@type": "Question",
      "name": "Intervenez-vous pour la maintenance d'immeubles et de copropriétés à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Oui, HB SERVICES assure la maintenance complète d'immeubles résidentiels et commerciaux à Genève. Nous travaillons avec les régies immobilières, les syndics de copropriété et les gestionnaires d'actifs. Nos prestations incluent la maintenance des installations électriques, sanitaires, de chauffage et de ventilation des parties communes et des appartements." }
    },
    {
      "@type": "Question",
      "name": "Pouvez-vous effectuer un diagnostic complet de mes installations à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Absolument. HB SERVICES propose des diagnostics complets de vos installations CVSE (Chauffage, Ventilation, Sanitaire, Électricité) à Genève. Ce diagnostic permet d'identifier les problèmes existants, les risques potentiels et les travaux de mise aux normes nécessaires. Un rapport détaillé vous est remis avec nos recommandations." }
    },
    {
      "@type": "Question",
      "name": "Dans quelles zones de Genève intervenez-vous pour la maintenance ?",
      "acceptedAnswer": { "@type": "Answer", "text": "HB SERVICES intervient pour la maintenance dans tout le canton de Genève : Meyrin, Carouge, Lancy, Vernier, Onex, Thônex, Grand-Saconnex, Chêne-Bougeries, Bernex, Plan-les-Ouates, Satigny et toutes les autres communes genevoises. Nous couvrons également Lausanne, Vaud, Fribourg et le Valais pour les contrats de maintenance." }
    }
  ]
};

export default function Maintenance() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Dépannage Urgence Neuenegg 24/7 | Électricité Plomberie Chauffage - CasaReNovaPlus"
        description="Dépannage urgence 24h/24 7j/7 à Genève. Panne électrique, fuite eau, chauffage en panne, VMC. Intervention rapide Meyrin, Carouge, Lancy, Vernier. Appelez le 079 761 62 82. Devis gratuit."
        keywords="dépannage urgence Genève, urgence électricité Genève, urgence plomberie Genève, urgence chauffage Genève, panne électrique Genève, fuite eau urgence Genève, chauffage en panne Genève, maintenance 24h Genève, dépannage 24/7 Genève, intervention urgente Genève, plombier urgence nuit Genève, électricien urgence week-end Genève, dépannage Meyrin Carouge Lancy"
        canonical={`${import.meta.env.VITE_SITE_URL}/maintenance`}
        schema={schema}
      />
      {/* FAQ Schema JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Header />
      <MaintenanceHero />
      <MaintenanceServices />
      <MaintenanceProcess />
      <MaintenanceFAQ />
      <EmergencyContact />
      <Footer />
    </div>
  );
}
